import { ampli, BrowserClient, Environment, LoadOptions } from "src/ampli"
import { plugin as sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { events } from 'src/engagement/events'
import React, { createContext, FC, ReactNode, useLayoutEffect, useMemo, useState } from "react"
import { AmplitudeLoadingScreen } from 'src/components/AmplitudeLoadingScreen'

const { GATSBY_AMPLITUDE_ENVIRONMENT } = process.env

export type Context = { client: BrowserClient | undefined }

export const AmplitudeContext = createContext<Context>({
  client: undefined,
})

export const AmplitudeProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [client, setClient] = useState<BrowserClient | undefined>(undefined)

  useLayoutEffect(() => {
    if (!ampli.isLoaded) {
      const loadConfig: LoadOptions = {
        environment: GATSBY_AMPLITUDE_ENVIRONMENT as Environment,
        client: {
          configuration: {
            autocapture: {
              pageViews: true,
              sessions: true,
              formInteractions: true,
              fileDownloads: true,
              attribution: true, // Crucial to keep marketing data
              elementInteractions: true, // The fix
              frustrationInteractions: true // tracks dead clicks and rage clicks
            }
          }
        }
      }
      console.log('Initializing Ampli with', { loadConfig })
      const result = ampli.load(loadConfig)
      result.promise.then(() => {
        const sessionReplayTracking = sessionReplayPlugin()
        ampli.client.add(sessionReplayTracking)
        setClient(ampli.client)
        events.emit('ready', ampli.client)
      })
    }
  }, [])

  const context = useMemo(() => ({ client }), [client])

  if (!client) {
    return <AmplitudeLoadingScreen />
  }

  return (
    <AmplitudeContext.Provider value={context}>
      {children}
    </AmplitudeContext.Provider>
  )
}
